import { getPagePath } from "../libs/helpers/location";
import { getPageNames } from "../constants/datalayer";
import { loadPage } from "../redux/page/page.actions";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useActions } from "./useActions";

const useDatalayer = () => {
    const actions = useActions(
        {
            loadPage,
        },
        []
    );
    const url = useLocation();
    useLayoutEffect(() => {
        actions.loadPage(
            getPagePath(url.pathname),
            getPageNames(url.pathname),
            url.pathname
        );
    }, [url, actions]);
};

export default useDatalayer;
